import React, { useState } from 'react';
import InfoDialog from '../../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import CusSwitch from '../../../../components/material-ui/CusSwitch';
import CusInput from '../../../../components/material-ui/CusInput';
import { API_FINANCE } from '../../../../api/finance';
import useToast from '../../../../hooks/useToast';

export default function PaymentRejectModal({
  openRejectId,
  setOpenRejectId,
  updateInfo,
  payout = []
}) {
  const { t } = useTranslation();
  const [refund, setRefund] = useState(true);
  const [comment, setComment] = useState('');
  const { successToast } = useToast();

  const onSave = () => {
    const data = { invoiceId: openRejectId, refund, comment };

    API_FINANCE.payout
      .reject(data)
      .then((e) => {
        successToast('The application was successfully rejected');
        setOpenRejectId(false);
        updateInfo(openRejectId, e.data.data);
      })
      .catch(console.log);
  };

  return (
    <InfoDialog
      open={openRejectId}
      maxWidth="sm"
      title={`${t('Application Invoice')} #${openRejectId}`}
      saveText={'Reject'}
      onClose={() => setOpenRejectId(false)}
      onSaveClick={onSave}>
      <Stack gap={2} mt={2}>
        <Typography color="textSecondary" component="span">
          {t('Decline payment of')}{' '}
          <Typography component="span" fontWeight={600}>
            {payout[2]}
          </Typography>{' '}
          {payout[5]}
        </Typography>

        <CusSwitch
          label={'Make a refund to your game balance'}
          checked={refund}
          onChange={() => setRefund((prev) => !prev)}
        />

        <CusInput
          label={'Comment'}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
        />
      </Stack>
    </InfoDialog>
  );
}
